
<h2>Do you have all the ingredients?</h2>
<div *ngFor="let ingredient of ingredients; ">
  <!-- Add check button -->
  <app-recipe-ingredient [ingredient]="ingredient" [scale]="scale"></app-recipe-ingredient>
</div>